import React from 'react';
import { Row, Col, Button, Navbar, FormGroup, FormControl, Alert, ControlLabel } from 'react-bootstrap';

import FieldGroup from './common/FieldGroup.jsx';

import {
  colorDisplay, sizingDisplay
} from '../constants/common';

export default class LabelEditComponent extends React.Component {

  componentDidMount() {
  }

  componentWillUnmount() {
    this.props.cleanInput();
  }

  handleSearchLabelId(searchLabelIdInput) {
    this.props.searchLabelId(searchLabelIdInput);
  }

  editItem() {
    this.props.editOrderLabel(this.props.labelFormBean);
  }

  syncItemData() {
  }

  render() {

    let alertDiv = null;
    if (this.props.alertStyle || this.props.alertMessage) {
      alertDiv = (
        <Alert bsStyle={this.props.alertStyle} onDismiss={this.props.cleanAlert}>
          {this.props.alertMessage}
        </Alert>
      );
    }

    let alertSearchDiv = null;
    if (this.props.alertSearchStyle || this.props.alertSearchMessage) {
      alertSearchDiv = (
        <Alert bsStyle={this.props.alertSearchStyle} onDismiss={this.props.cleanAlert}>
          {this.props.alertSearchMessage}
        </Alert>
      );
    }

    let showNotPair = null;
    let disableEdit = false;
    let showEdit = ''
    if (this.props.labelFormBean.get('orderItemId') == null) {
      if (this.props.labelFormBean.get('orderLabelId') != null) {
        showNotPair = (<span style={{ marginLeft: 10, color: 'blue' }}> 衣褲尚未與洗標配對，僅能修改註解&製造日期 !</span>)
      }
      showEdit = 'none';
    }
    if (this.props.labelFormBean.get('orderLabelId') == null) {
      disableEdit = true;
    }

    let colorArray = [];
    let sizingArray = [];
    if (this.props.labelFormBean.get('colorValues')) {
			colorArray = this.props.labelFormBean.get('colorValues').split(",");
		}
		if (this.props.labelFormBean.get('sizingValues')) {
			sizingArray = this.props.labelFormBean.get('sizingValues').split(",");
		}

    return (
      <div>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={6}>
            {alertSearchDiv}
          </Col>
        </Row>
        <Navbar.Form>
          <Row>
            <FormGroup>
              <FormControl type="text" placeholder='洗標條碼 搜尋' inputRef={ref => { this.searchLabelIdInput = ref; }} tabIndex="20"
                onKeyDown={(event) => {
                  // keyCode = 13 => eneter 鍵
                  if (event.keyCode === 13) {
                    this.handleSearchLabelId(this.searchLabelIdInput.value);
                  }
                }} />
            </FormGroup>
            <span className="glyphicon glyphicon-search" style={{ marginLeft: 10, cursor: 'pointer' }} onClick={(event) => {
              this.handleSearchLabelId(this.searchLabelIdInput.value);
            }} tabIndex="21" />
          </Row>
        </Navbar.Form>
        <div>
          <hr />
          <Row style={{ marginTop: 10 }}>
            <Col xs={12} sm={6}>
              {alertDiv}
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12}>
              <Button onClick={(event) => {
                this.editItem();
              }} bsStyle="info" disabled={disableEdit}>
                修改洗標內容
					    </Button>
              {showNotPair}
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={12} sm={6}>
              <label>洗標條碼:</label>{' '}{this.props.labelFormBean.get('orderLabelId')} 
              <span style={{display: 'none'}}><a onClick={(e) => { this.syncItemData() }}><img src="sync.png" title="同步衣褲資料" alt="同步衣褲資料" style={{ cursor: 'pointer' }} /></a></span><br />
              <label>訂單編號:</label>{' '}{this.props.labelFormBean.get('orderId')} <br />
              <label>序號:</label>{' '}{this.props.labelFormBean.get('serialNo')}
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col xs={12} sm={6}>
            <FieldGroup
                id="careLabel"
                type="text"
                label="洗標註解"
                value={this.props.labelFormBean.get('careLabel')}
                placeholder=""
                onChange={(id, value) => {
                  this.props.setValue(id, value);
                }}
                validation={this.props.labelFormBeanValidation.get('careLabel')}
                componentClass="textarea"
                rows="3"
              />
              <FieldGroup
                id="manufactureDate"
                type="date"
                label="製造日期"
                value={this.props.labelFormBean.get('manufactureDate')}
                placeholder=""
                required="true"
                onChange={(id, value) => {
                  this.props.setValue(id, value);
                }}
                validation={this.props.labelFormBeanValidation.get('manufactureDate')}
              />
              <div style={{display: showEdit}}>
              <ControlLabel>顏色<span className="text-danger" style={{ marginLeft: 5 }}>*</span></ControlLabel><br />
              {
                colorArray.map((colorValue, key) => (
                  <span key={'color_' + key} style={{ paddingRight: 5 }}><input type="radio" name="color" value={colorValue}
                    onChange={(event) => {
                      this.props.setValue("color", event.target.value);
                    }} checked={this.props.labelFormBean.get('color') === colorValue} />{colorDisplay(colorValue)}</span>
                ))
              }
              <br /><br />
              <ControlLabel>尺寸<span className="text-danger" style={{ marginLeft: 5 }}>*</span></ControlLabel><br />
              {
                sizingArray.map((sizeValue, key) => (
                  <span key={'sizing_' + key} style={{ paddingRight: 5 }}><input type="radio" name="sizing" value={sizeValue}
                    onChange={(event) => {
                      this.props.setValue("sizing", event.target.value);
                    }} checked={this.props.labelFormBean.get('sizing') === sizeValue} />{sizingDisplay(sizeValue)}</span>
                ))
              }
              <br /><br />
              <FieldGroup
                id="specialNote"
                type="text"
                label="特殊規格註記"
                value={this.props.labelFormBean.get('specialNote')}
                placeholder=""
                onChange={(id, value) => {
                  this.props.setValue(id, value);
                }}
                validation={this.props.labelFormBeanValidation.get('specialNote')}
              />
              </div>
            </Col>
          </Row>
          </div>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/LabelEditComponent.jsx